export default "__VITE_ASSET__C1y2RlGs__"